import { PermissionsList } from '@/constants/permissionsList';

const isSystemAdministrator = (userGroup?: string): boolean => {
  return userGroup === 'SystemAdministrators';
};

const isManager = (userGroup?: string): boolean => {
  return userGroup === 'Manager';
};

export const getUsersPermissions = (permissions: PermissionsList | undefined, userGroup?: string) => {
  if (isSystemAdministrator(userGroup)) {
    return {
      canCreate: true,
      canView: true,
      canEdit: true,
      canDelete: true
    };
  }

  if (isManager(userGroup)) {
    return {
      canCreate: true,
      canView: true,
      canEdit: true,
      canDelete: true
    };
  }

  return {
    canCreate: false,
    canView: false,
    canEdit: false,
    canDelete: false
  };
};

export const getLocationsPermissions = (permissions: PermissionsList | undefined, userGroup?: string) => {
  if (isSystemAdministrator(userGroup)) {
    return {
      canCreate: true,
      canView: true,
      canEditMainInfo: true,
      canAssignUnassignTurbines: true,
      canAssignUnassignUsers: true,
      canAssignUnassignCompanies: true,
      canEditDataPointVisibility: true,
      canDelete: true
    };
  }

  if (isManager(userGroup)) {
    return {
      canCreate: false,
      canView: true,
      canEditMainInfo: false,
      canAssignUnassignTurbines: true,
      canAssignUnassignUsers: true,
      canAssignUnassignCompanies: true,
      canEditDataPointVisibility: true,
      canDelete: false
    };
  }

  return {
    canCreate: false,
    canView: false,
    canEditMainInfo: false,
    canAssignUnassignTurbines: false,
    canAssignUnassignUsers: false,
    canAssignUnassignCompanies: false,
    canEditDataPointVisibility: false,
    canDelete: false
  };
};

export const getTurbinesPermissions = (permissions: PermissionsList | undefined, userGroup?: string) => {
  if (isSystemAdministrator(userGroup)) {
    return {
      canCreate: true,
      canView: true,
      canEdit: true,
      canDelete: true
    };
  }

  if (isManager(userGroup)) {
    return {
      canCreate: false,
      canView: true,
      canEdit: false,
      canDelete: false
    };
  }

  return {
    canCreate: false,
    canView: false,
    canEdit: false,
    canDelete: false
  };
};
